// extracted by mini-css-extract-plugin
module.exports = {"selectorButton":"_2VJ-H","btnLink":"_2xyng"};